<script lang="ts">export let size = "24";
const height = size;
const width = size;
</script>

<svg
	{width}
	{height}
	style="fill: currentColor"
	viewBox="0 0 24 24"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12.0059 6.75586C11.5916 6.75586 11.2559 7.09165 11.2559 7.50586V11.25H7.5C7.08579 11.25 6.75 11.5858 6.75 12C6.75 12.4142 7.08579 12.75 7.5 12.75H11.2559V16.5059C11.256 16.92 11.5917 17.2559 12.0059 17.2559C12.4199 17.2557 12.7557 16.9199 12.7559 16.5059V12.75H16.5C16.9142 12.75 17.25 12.4142 17.25 12C17.25 11.5858 16.9142 11.25 16.5 11.25H12.7559V7.50586C12.7559 7.09172 12.42 6.75598 12.0059 6.75586Z"
		fill="currentColor"
	/>
</svg>
